module.exports = __webpack_public_path__ + "img/message.d9d22510.svg";